import Section from '../ui/Section/Section'
import Reveal from '../ui/Reveal/Reveal'
import ProjectCard from './ProjectCard'
import { projects } from '../../data/portfolio'
import styles from './Projects.module.css'

const Projects = ({ index }) => {
  if (!projects.length) return null

  return (
    <Section
      id="projects"
      index={index}
      title="Selected work"
      eyebrow="Projects"
      lead="A few things I've built. Each one taught me something I still use."
    >
      <div className={styles.grid}>
        {projects.map((project, position) => (
          <Reveal
            key={project.id}
            delay={position * 80}
            className={`${styles.gridItem} ${
              project.featured ? styles.featuredItem : ''
            }`.trim()}
          >
            <ProjectCard project={project} />
          </Reveal>
        ))}
      </div>
    </Section>
  )
}

export default Projects
